"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.registerAll = exports.find = exports.get = exports.register = exports.EDiveEquipSlot = exports.EDiveObjectSpecialEffect = exports.EDiveObjectType = void 0;
var rogueColors_1 = require("@dive/colors/rogueColors");
var entitiesUtils_sidecar_1 = require("@entities/entitiesUtils-sidecar");
var onceOnly_sidecar_1 = require("@lib/onceOnly-sidecar");
var sprites_sidecar_1 = require("@sprites/sprites-sidecar");
var diveCrew_hero_data_1 = require("@voyage/crew/diveCrew_hero_data");
var EDiveObjectType;
(function (EDiveObjectType) {
    EDiveObjectType[EDiveObjectType["Default"] = -1] = "Default";
    EDiveObjectType[EDiveObjectType["Null"] = 0] = "Null";
    EDiveObjectType[EDiveObjectType["TreasureChest"] = 1] = "TreasureChest";
    EDiveObjectType[EDiveObjectType["Barrel"] = 2] = "Barrel";
    EDiveObjectType[EDiveObjectType["BarrelSmashed"] = 3] = "BarrelSmashed";
    EDiveObjectType[EDiveObjectType["Crate"] = 4] = "Crate";
    EDiveObjectType[EDiveObjectType["CrateSmashed"] = 5] = "CrateSmashed";
    EDiveObjectType[EDiveObjectType["SpiderEgg"] = 10] = "SpiderEgg";
    EDiveObjectType[EDiveObjectType["SpiderEggCracked"] = 11] = "SpiderEggCracked";
    EDiveObjectType[EDiveObjectType["SpiderWeb"] = 12] = "SpiderWeb";
    EDiveObjectType[EDiveObjectType["GoldPile"] = 20] = "GoldPile";
    EDiveObjectType[EDiveObjectType["Key1"] = 22] = "Key1";
    EDiveObjectType[EDiveObjectType["Key2"] = 23] = "Key2";
    EDiveObjectType[EDiveObjectType["Door"] = 30] = "Door";
    EDiveObjectType[EDiveObjectType["Firepit"] = 35] = "Firepit";
    EDiveObjectType[EDiveObjectType["Weapon_Sword"] = 41] = "Weapon_Sword";
    EDiveObjectType[EDiveObjectType["Weapon_Spellbook"] = 42] = "Weapon_Spellbook";
    EDiveObjectType[EDiveObjectType["Weapon_Bow"] = 43] = "Weapon_Bow";
    EDiveObjectType[EDiveObjectType["Weapon_Pistols"] = 44] = "Weapon_Pistols";
    EDiveObjectType[EDiveObjectType["Scroll"] = 50] = "Scroll";
    EDiveObjectType[EDiveObjectType["Potion1"] = 51] = "Potion1";
    EDiveObjectType[EDiveObjectType["Potion2"] = 52] = "Potion2";
})(EDiveObjectType = exports.EDiveObjectType || (exports.EDiveObjectType = {}));
var EDiveObjectSpecialEffect;
(function (EDiveObjectSpecialEffect) {
    EDiveObjectSpecialEffect[EDiveObjectSpecialEffect["None"] = 0] = "None";
    EDiveObjectSpecialEffect[EDiveObjectSpecialEffect["TurnIntoSpider"] = 1] = "TurnIntoSpider";
    EDiveObjectSpecialEffect[EDiveObjectSpecialEffect["WebStun"] = 2] = "WebStun";
})(EDiveObjectSpecialEffect = exports.EDiveObjectSpecialEffect || (exports.EDiveObjectSpecialEffect = {}));
var EDiveEquipSlot;
(function (EDiveEquipSlot) {
    EDiveEquipSlot[EDiveEquipSlot["None"] = 0] = "None";
    EDiveEquipSlot[EDiveEquipSlot["Weapon"] = 1] = "Weapon";
    EDiveEquipSlot[EDiveEquipSlot["Item"] = 2] = "Item";
    EDiveEquipSlot[EDiveEquipSlot["Loot"] = 3] = "Loot";
})(EDiveEquipSlot = exports.EDiveEquipSlot || (exports.EDiveEquipSlot = {}));
var _default = {
    type: 'default',
    key: EDiveObjectType.Default,
    frames: sprites_sidecar_1.sprites.voyTileCheckerFine1,
    smashInto: EDiveObjectType.Null,
    canOpen: false,
    canBeWalkedOn: true,
    canBeWalkedOnIfOpen: false,
    canBePickedUp: false,
    tint: 0xffffff,
    isDualColor: false,
    heroClass: diveCrew_hero_data_1.EDiveHeroSubtype.None,
    equipSlot: EDiveEquipSlot.None,
    dropChance: 0,
    minDrops: 1,
    maxDrops: 1,
    maxAbility1Uses: 0,
    maxAbility2Uses: 0,
    specialEffect: EDiveObjectSpecialEffect.None,
    cover: 0,
    coverFunc: null,
};
var dataType = 'dive-objects';
var dataList = [];
var dataMapType = {};
function register(data) {
    return entitiesUtils_sidecar_1.entitiesUtils.genericRegisterData(dataType, data, _default, dataList, dataMapType);
}
exports.register = register;
function get(type) {
    return entitiesUtils_sidecar_1.entitiesUtils.genericGetData(dataType, dataMapType, type);
}
exports.get = get;
var find = function (key) {
    return entitiesUtils_sidecar_1.entitiesUtils.genericFindData(dataType, dataList, key);
};
exports.find = find;
function registerAll() {
    onceOnly_sidecar_1.onceOnly.ensureCalledOnlyOnce(dataType);
    register({
        key: EDiveObjectType.Null,
        frames: sprites_sidecar_1.sprites.voyTileCheckerFine2,
        type: 'null',
    });
    register({
        key: EDiveObjectType.GoldPile,
        frames: sprites_sidecar_1.sprites.diveItemsWeeDungGoldPng,
        type: 'gold-pile',
        canBePickedUp: true,
        equipSlot: EDiveEquipSlot.Loot,
    });
    register({
        key: EDiveObjectType.TreasureChest,
        frames: __spreadArray(__spreadArray(__spreadArray([], __read(sprites_sidecar_1.sprites.diveItemsWeeDungChestPng)), __read(sprites_sidecar_1.sprites.diveItemsWeeDungChestOpenPng)), __read(sprites_sidecar_1.sprites.diveItemsWeeDungChestEmptyPng)),
        type: 'treasure-chest',
        canBeWalkedOn: false,
        canBeWalkedOnIfOpen: false,
        canOpen: true,
        dropChance: 0.9,
        minDrops: 2,
        maxDrops: 4,
        cover: 1,
    });
    register({
        key: EDiveObjectType.Barrel,
        frames: sprites_sidecar_1.sprites.diveItemsWeeDungBarrelPng,
        type: 'barrel',
        canBeWalkedOn: false,
        smashInto: EDiveObjectType.BarrelSmashed,
        dropChance: 0.75,
        cover: 1,
    });
    register({
        key: EDiveObjectType.BarrelSmashed,
        frames: sprites_sidecar_1.sprites.diveItemsBarrelBroken,
        type: 'barrel-smashed',
        canBeWalkedOn: true,
        cover: 0,
    });
    register({
        key: EDiveObjectType.Crate,
        frames: sprites_sidecar_1.sprites.diveItemsWeeDungCratePng,
        type: 'crate',
        canBeWalkedOn: false,
        smashInto: EDiveObjectType.CrateSmashed,
        dropChance: 0.95,
        cover: 1,
    });
    register({
        key: EDiveObjectType.CrateSmashed,
        frames: sprites_sidecar_1.sprites.diveItemsCrateBroken,
        type: 'crate-smashed',
        canBeWalkedOn: true,
    });
    register({
        key: EDiveObjectType.SpiderEgg,
        frames: sprites_sidecar_1.sprites.diveMonsters4SpiderEgg,
        type: 'spider-egg',
        canBeWalkedOn: false,
        smashInto: EDiveObjectType.SpiderEggCracked,
        specialEffect: EDiveObjectSpecialEffect.TurnIntoSpider,
        dropChance: 0,
        cover: 1,
    });
    register({
        key: EDiveObjectType.SpiderEggCracked,
        frames: sprites_sidecar_1.sprites.diveMonsters4SpiderEggCracked,
        type: 'spider-egg-cracked',
        canBeWalkedOn: true,
    });
    register({
        key: EDiveObjectType.SpiderWeb,
        frames: sprites_sidecar_1.sprites.diveMonsters4SpiderWeb,
        type: 'spider-web',
        canBeWalkedOn: true,
        specialEffect: EDiveObjectSpecialEffect.WebStun,
        // TODO: stun effect
    });
    // Hero weapons
    register({
        key: EDiveObjectType.Weapon_Sword,
        frames: sprites_sidecar_1.sprites.diveItemsWeeDungSwordPng,
        type: 'weapon-sword',
        canBePickedUp: true,
        heroClass: diveCrew_hero_data_1.EDiveHeroSubtype.Soldier,
        equipSlot: EDiveEquipSlot.Weapon,
    });
    register({
        key: EDiveObjectType.Weapon_Spellbook,
        frames: sprites_sidecar_1.sprites.diveItemsWeeDungBookBrownPng,
        type: 'weapon-spellbook',
        canBePickedUp: true,
        heroClass: diveCrew_hero_data_1.EDiveHeroSubtype.Wizard,
        equipSlot: EDiveEquipSlot.Weapon,
        maxAbility1Uses: 4,
        maxAbility2Uses: 2,
    });
    register({
        key: EDiveObjectType.Weapon_Bow,
        frames: sprites_sidecar_1.sprites.diveItemsBowAndArrow,
        type: 'weapon-bow',
        canBePickedUp: true,
        heroClass: diveCrew_hero_data_1.EDiveHeroSubtype.Archer,
        equipSlot: EDiveEquipSlot.Weapon,
    });
    register({
        key: EDiveObjectType.Weapon_Pistols,
        frames: sprites_sidecar_1.sprites.diveItemsWeeDungShieldPng,
        type: 'weapon-pistols',
        canBePickedUp: true,
        heroClass: diveCrew_hero_data_1.EDiveHeroSubtype.Gunslinger,
        equipSlot: EDiveEquipSlot.Weapon,
    });
    register({
        key: EDiveObjectType.Key1,
        frames: sprites_sidecar_1.sprites.diveItemsWeeDungKeyGoldPng,
        type: 'key1',
        canBePickedUp: true,
        equipSlot: EDiveEquipSlot.Loot,
    });
    register({
        key: EDiveObjectType.Key2,
        frames: sprites_sidecar_1.sprites.diveItemsWeeDungKeyMagicPng,
        type: 'key2',
        canBePickedUp: true,
        equipSlot: EDiveEquipSlot.Loot,
    });
    register({
        key: EDiveObjectType.Door,
        frames: __spreadArray(__spreadArray([], __read(sprites_sidecar_1.sprites.diveItemsWeeDungDoorBrownPng)), __read(sprites_sidecar_1.sprites.diveItemsWeeDungDoorBrownOpen)),
        type: 'door',
        canOpen: true,
        canBeWalkedOn: false,
        canBeWalkedOnIfOpen: true,
        canBePickedUp: false,
        coverFunc: function (c) { return (c.isOpen ? 0 : 2); },
        //cover: 1,
        // TODO: special cover check
    });
    register({
        key: EDiveObjectType.Firepit,
        frames: __spreadArray([], __read(sprites_sidecar_1.sprites.diveItemsFirepit1)),
        type: 'firepit',
        canOpen: false,
        canBeWalkedOn: false,
        canBePickedUp: false,
        cover: 1,
    });
    register({
        key: EDiveObjectType.Scroll,
        frames: sprites_sidecar_1.sprites.diveItemsWeeDungScrollPng,
        type: 'scroll',
        canBePickedUp: true,
        equipSlot: EDiveEquipSlot.Item,
    });
    // TODO: randomize potion colors and effects?
    register({
        key: EDiveObjectType.Potion1,
        frames: __spreadArray(__spreadArray([], __read(sprites_sidecar_1.sprites.diveItemsPotionBackColor)), __read(sprites_sidecar_1.sprites.diveItemsWeeDungPotionEmptyPng)),
        type: 'potion1',
        canBePickedUp: true,
        tint: rogueColors_1.rogueColors.red,
        isDualColor: true,
        equipSlot: EDiveEquipSlot.Item,
    });
    register({
        key: EDiveObjectType.Potion2,
        frames: __spreadArray(__spreadArray([], __read(sprites_sidecar_1.sprites.diveItemsPotionBackColor)), __read(sprites_sidecar_1.sprites.diveItemsWeeDungPotionEmptyPng)),
        type: 'potion2',
        canBePickedUp: true,
        tint: rogueColors_1.rogueColors.lightBlue,
        isDualColor: true,
        equipSlot: EDiveEquipSlot.Item,
    });
}
exports.registerAll = registerAll;
